import {createRouter, createWebHashHistory} from 'vue-router'
import Index from '../views/index/layout.vue'

const routes = [{
    path: '/', component: Index, children: [{
        path: '', meta: {
            isLogin: true
        }, component: () => import('../views/index')
    }, {
        path: 'profile', meta: {
            isLogin: true
        }, component: () => import('../views/index/profile')
    }, {
        path: 'partner', meta: {
            isLogin: true
        }, component: () => import('../views/index/partner')
    }, {
        path: 'partner-detail', meta: {
            isLogin: true
        }, component: () => import('../views/index/partner-detail')
    }, {
        path: 'store', component: () => import('../views/index/store')
    }, {
        path: 'notice', meta: {
            isLogin: true
        }, component: () => import('../views/index/notice')
    }]
}, {
    path: '/user', component: () => import('../views/user/layout.vue'), children: [{
        path: 'login', component: () => import('../views/user/login.vue')
    }, {
        path: 'register', component: () => import('../views/user/register.vue')
    }, {
        path: 'forgetPsd', component: () => import('../views/user/forgetPsd.vue')
    }, {
        path: 'outputIntegral', component: () => import('../views/user/outputIntegral.vue')
    }, {
        path: 'getIntegral', component: () => import('../views/user/getIntegral.vue')
    }, {
        path: 'draw', component: () => import('../views/user/draw.vue')
    }, {
        path: 'again', component: () => import('../views/user/again.vue')
    }, {
        path: 'takePosition', component: () => import('../views/user/takePosition.vue')
    }, {
        path: 'pledge', component: () => import('../views/user/pledge.vue')
    }, {
        path: 'pledges', component: () => import('../views/user/pledges.vue')
    }, {
        path: 'transfer', component: () => import('../views/user/transfer.vue')
    }, {
        path: 'gathering', component: () => import('../views/user/gathering.vue')
    }, {
        path: 'drawType', component: () => import('../views/user/drawType.vue')
    }, {
        path: 'drawUpd', component: () => import('../views/user/drawUpd.vue')
    }, {
        path: 'myTeam', component: () => import('../views/user/myTeam.vue')
    }, {
        path: 'share', component: () => import('../views/user/share.vue')
    }, {
        path: 'applyStudio', component: () => import('../views/user/applyStudio.vue')
    }, {
        path: 'set', component: () => import('../views/user/set.vue')
    }, {
        path: 'personal', component: () => import('../views/user/personal.vue')
    }, {
        path: 'editUser', component: () => import('../views/user/editUser.vue')
    }, {
        path: 'safetySet', component: () => import('../views/user/safetySet.vue')
    }, {
        path: 'updPsd', component: () => import('../views/user/updPsd.vue')
    }]
}, {
    path: '/record', component: () => import('../views/record/layout.vue'), children: [{
        path: 'accountRec', component: () => import('../views/record/accountRec.vue')
    }, {
        path: 'againRec', component: () => import('../views/record/againRec.vue')
    }, {
        path: 'getRec', component: () => import('../views/record/getRec.vue')
    }, {
        path: 'releaseRec', component: () => import('../views/record/releaseRec.vue')
    }, {
        path: 'pledgeRec', component: () => import('../views/record/pledgeRec.vue')
    }, {
        path: 'takeExpire', component: () => import('../views/record/takeExpire.vue')
    }, {
        path: 'transferRec', component: () => import('../views/record/transferRec.vue')
    }, {
        path: 'dealRec', component: () => import('../views/record/dealRec.vue')
    }, {
        path: 'applyRec', component: () => import('../views/record/applyRec.vue')
    }, {
        path: 'drawRec', component: () => import('../views/record/drawRec.vue')
    }]
}, {
    path: '/noticeList', component: () => import('../views/noticeList/layout.vue'), children: [{
        path: '', component: () => import('../views/noticeList/index.vue')
    }, {
        path: 'det', component: () => import('../views/noticeList/det.vue')
    }, {
        path: 'assetDet', component: () => import('../views/noticeList/assetDet.vue')
    }]
}, {
    path: '/dealHall', component: () => import('../views/dealHall/layout.vue'), children: [{
        path: '', component: () => import('../views/dealHall/index.vue')
    }, {
        path: 'myAlone', component: () => import('../views/dealHall/myAlone.vue')
    }, {
        path: 'orderDet', component: () => import('../views/dealHall/orderDet.vue')
    }, {
        path: 'issueOrder', component: () => import('../views/dealHall/issueOrder.vue')
    }, {
        path: 'allege', component: () => import('../views/dealHall/allege.vue')
    }, {
        path: 'myAllege', component: () => import('../views/dealHall/myAllege.vue')
    }, {
        path: 'applyDeal', component: () => import('../views/dealHall/applyDeal.vue')
    }]
}, {
    path: '/shopping', component: () => import('../views/shopping/layout.vue'), children: [{
        path: '', component: () => import('../views/shopping/index.vue')
    }, {
        path: 'detail', component: () => import('../views/shopping/detail.vue')
    }, {
        path: 'submitOrder', component: () => import('../views/shopping/submitOrder.vue')
    }, {
        path: 'pay', component: () => import('../views/shopping/pay.vue')
    }, {
        path: 'myOrder', component: () => import('../views/shopping/myOrder.vue')
    }, {
        path: 'orderDet', component: () => import('../views/shopping/orderDet.vue')
    }, {
        path: 'search', component: () => import('../views/shopping/search.vue')
    }]
}, {
    path: '/address', component: () => import('../views/address/layout.vue'), children: [{
        path: '', component: () => import('../views/address/index.vue')
    }, {
        path: 'add', component: () => import('../views/address/add.vue')
    }]
}, {
    path: '/arrange', children: [{
        path: 'auto', component: () => import('../views/arrange/Automatically.vue')
    }, {
        path: 'myqueue', component: () => import('../views/arrange/MyQueue.vue')
    }, {
        path: 'queue', component: () => import('../views/arrange/ArrangeQueue.vue')
    }, {
        path: 'upgrade', component: () => import('../views/arrange/Upgrade.vue')
    }, {
        path: 'partner', component: () => import('../views/arrange/Partner.vue')
    }, {
        path: 'partnerRecord', component: () => import('../views/arrange/PartnerRecord.vue')
    }]
}]

const router = createRouter({
    history: createWebHashHistory(), routes
})

export default router
